/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VirtualContainerReason } from '../../models/virtual-container-reason';

export interface GetVirtualSecondaryContainerReasons$Params {
}

export function getVirtualSecondaryContainerReasons(http: HttpClient, rootUrl: string, params?: GetVirtualSecondaryContainerReasons$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VirtualContainerReason>>> {
  const rb = new RequestBuilder(rootUrl, getVirtualSecondaryContainerReasons.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VirtualContainerReason>>;
    })
  );
}

getVirtualSecondaryContainerReasons.PATH = '/api/v1/SecondaryMaterial/VirtualSecondaryContainerReasons';
